import { render } from "./GongBuView.vue?vue&type=template&id=34e63773&scoped=true&ts=true"
import script from "./GongBuView.vue?vue&type=script&lang=ts"
export * from "./GongBuView.vue?vue&type=script&lang=ts"

import "./GongBuView.vue?vue&type=style&index=0&id=34e63773&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e63773"]])

export default __exports__